import { Field } from "formik";
import React, { BaseSyntheticEvent, FC } from "react";
import { useTranslation } from "react-i18next";

type Props = {
  index: number;
  currentUser: string;
  user: {
    id: number;
    email: string;
  };
  email: string;
  setFieldValue: any;
  accessType?: number;
  accessTypeOwner?: string;
  key: number | string;
  onChangeAccessType: () => void;
};

export const UserAccess: FC<Props> = ({
  email,
  index,
  setFieldValue,
  accessType,
  currentUser,
  accessTypeOwner,
  onChangeAccessType,
}) => {
  const { t } = useTranslation();
  return (
    <li
      className="d-flex align-items-center justify-content-between ps-3 mb-3"
      key={email}
    >
      <div className="col-7 d-flex align-items-center mb-3 mb-lg-0">
        <div
          className="me-3 me-md-4 avatar fs-7 text-white d-flex justify-content-center align-items-center"
          style={{ height: "26px", width: "26px" }}
        >
          {email[0].toUpperCase()}
        </div>
        <p className="m-0 text-break col-8">{email}</p>
      </div>
      <div className="form-floating position-relative d-flex align-items-center col-5 col-lg-3">
        <Field
          as="select"
          name={`userAccesses[${index}].accessType`}
          onChange={(event: BaseSyntheticEvent) => {
            setFieldValue(
              `userAccesses[${index}].accessType`,
              +event.target.value
            );
            onChangeAccessType();
          }}
          className={`form-select text-black d-flex align-items-center p-0 px-3 fs-6`}
          disabled={accessType === 1 && currentUser !== accessTypeOwner}
        >
          <option value={1}>{t("share.canView")}</option>
          <option value={2}>{t("share.canEdit")}</option>
          {currentUser === accessTypeOwner && (
            <option value={3}>{t("share.remove")}</option>
          )}
        </Field>
      </div>
    </li>
  );
};
